<template>
  <footer class="bg-gradient-to-r from-navy-500 to-navy-700 text-white">
    <div class="container-custom py-12">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Columna 1: Logo y Derechos -->
        <div class="space-y-4">
          <a href="#inicio" @click.prevent="scrollToTop" class="inline-block">
            <img
              src="/images/logo/logo-text-on-dark.svg"
              alt="Motoboy"
              class="h-12 w-auto object-contain"
              onerror="this.onerror=null; this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22150%22 height=%2250%22%3E%3Ctext x=%2210%22 y=%2235%22 font-family=%22Arial%22 font-size=%2230%22 font-weight=%22bold%22 fill=%22%23ffffff%22%3EMotoBoy%3C/text%3E%3C/svg%3E'"
            />
          </a>
          <p class="text-sm text-gray-300">
            {{ $t('footer.rights') }}
          </p>
          <a
            href="https://www.google.com/maps/place/Barcelona+2077,+Piso+6"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-start gap-2 text-sm text-gray-300 hover:text-primary transition-colors"
          >
            <font-awesome-icon icon="map-marker-alt" class="mt-1 flex-shrink-0" />
            <span>{{ $t('footer.address') }}</span>
          </a>
        </div>

        <!-- Columna 2: Horarios y Trabajo -->
        <div class="space-y-4">
          <h4 class="font-semibold text-lg text-primary mb-4">Información</h4>
          <div class="flex items-start gap-2 text-sm text-gray-300">
            <font-awesome-icon icon="clock" class="mt-1 flex-shrink-0" />
            <p>{{ $t('footer.schedule') }}</p>
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeEwCwI2hk5u5FknqfR2n33tK0xTUE5hMxKCOLddZFsyO1Tmg/viewform"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 text-sm text-primary hover:text-primary-400 transition-colors font-medium"
          >
            <font-awesome-icon icon="arrow-right" />
            <span>{{ $t('footer.workWithUs') }}</span>
          </a>
        </div>

        <!-- Columna 3: Contacto y Redes -->
        <div class="space-y-4">
          <h4 class="font-semibold text-lg text-primary mb-4">
            {{ $t('footer.commercial') }}
          </h4>
          <a
            href="mailto:ventas@motoboy.cl"
            class="flex items-center gap-2 text-sm text-gray-300 hover:text-primary transition-colors"
          >
            <font-awesome-icon icon="envelope" />
            <span>ventas@motoboy.cl</span>
          </a>
          <a
            href="https://wa.me/56992345248"
            target="_blank"
            rel="noopener noreferrer"
            class="flex items-center gap-2 text-sm text-gray-300 hover:text-primary transition-colors"
          >
            <font-awesome-icon :icon="['fab', 'whatsapp']" />
            <span>+569 9234 5248</span>
          </a>

          <!-- Redes Sociales -->
          <div class="flex items-center gap-4 pt-4">
            <a
              href="https://www.instagram.com/motoboychile.oficial"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-primary transition-colors"
              aria-label="Instagram"
            >
              <font-awesome-icon :icon="['fab', 'instagram']" class="text-2xl" />
            </a>
            <a
              href="https://www.facebook.com/motoboychilesa"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-primary transition-colors"
              aria-label="Facebook"
            >
              <font-awesome-icon :icon="['fab', 'facebook-f']" class="text-2xl" />
            </a>
            <a
              href="https://www.linkedin.com/company/motoboy-chile-spa/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-gray-300 hover:text-primary transition-colors"
              aria-label="LinkedIn"
            >
              <font-awesome-icon :icon="['fab', 'linkedin-in']" class="text-2xl" />
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom Row: Políticas y Webpay -->
      <div class="mt-8 pt-8 border-t border-gray-700 flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="flex flex-wrap items-center gap-4 text-sm">
          <a
            href="https://drive.google.com/file/d/1vzk0e8UeY0ubhwWEPLONmpp5grXtrQJs/view"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-300 hover:text-primary transition-colors"
          >
            {{ $t('footer.policies') }}
          </a>
          <span class="text-gray-600">|</span>
          <router-link
            to="/privacy-policy"
            class="text-gray-300 hover:text-primary transition-colors"
          >
            Política de Privacidad
          </router-link>
          <span class="text-gray-600">|</span>
          <router-link
            to="/terms-and-conditions"
            class="text-gray-300 hover:text-primary transition-colors"
          >
            Términos y Condiciones
          </router-link>
        </div>

        <div class="flex items-center gap-4">
          <img
            src="/images/webpay-logo.png"
            alt="Webpay"
            class="h-10 w-auto object-contain opacity-80"
            onerror="this.style.display='none'"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
const scrollToTop = () => {
  // Verificar si estamos en la página home
  const isHomePage = window.location.pathname === '/';

  if (!isHomePage) {
    // Si no estamos en home, navegar a home
    window.location.href = '/';
    return;
  }

  // Si estamos en home, hacer scroll al top
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
</script>
